import React from "react";
import TextEditor from "../../../components/TextEditor/TextEditor";

const TextModal = ({handleChange, localSettings}) => {

    return (
        <TextEditor
            value={localSettings.textInput || ""}
            startSize={localSettings.textSize || ""}
            onTextChange={(newContent) => handleChange("textInput", newContent)}
            onSizeChange={(newSize) => handleChange("textSize", newSize)}
            showTextSize={true}
        />
    )
}

export default TextModal;